/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Published
 */
export interface Published {}

/**
 * Check if a given object implements the Published interface.
 */
export function instanceOfPublished(value: object): boolean {
    return true;
}

export function PublishedFromJSON(json: any): Published {
    return PublishedFromJSONTyped(json, false);
}

export function PublishedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Published {
    return json;
}

export function PublishedToJSON(value?: Published | null): any {
    return value;
}
